// auth imports
import {Routes, Route, Navigate} from 'react-router-dom';
import {RequiredAuth} from './SecureRoute';

//  pages
import NoFoundPage from 'pages/404';
import HomePage from 'pages/Home';
import ProcessPage from 'pages/Process';
import SearchPage from 'pages/Search';
import ArtifactsPage from 'pages/Artifacts';
import {ArtifactPageType, E_QuickLinks} from 'app/types/Shared';
import {Box, LinearProgress} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {LogInAction, selectUserLogInStatus, selectUserType, setLogInStatus} from 'app/store/users/userSlice';
import {selectUserProfile, setLoading} from 'app/store/auth/authSlice';
import LogInPage from 'pages/LogIn';
import LogoutPage from 'pages/Logout';
import React from 'react';
import QuickLinksPage from 'pages/QuickLinks';
import ResourcePage from 'pages/Resources';
import {useUserLoginMutation} from 'app/store/registration/resgistrationApi';
import {CustomLoginCallback} from 'components/CustomLoginCallback/CustomLoginCallback';

// ==============================|| MAIN ROUTING ||============================== //

const LoadingElement = () => {
  const userType = useSelector(selectUserType);
  const userLogInStatus = useSelector(selectUserLogInStatus);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!userLogInStatus.isLoggedIn && userLogInStatus?.hasRedirected) {
      dispatch(setLogInStatus(LogInAction.EnableAll));
    }
  }, [dispatch, userLogInStatus]);

  if (!userType) {
    dispatch(setLoading(true));
  }
  return (
    <Box sx={{pt: 10, width: '100%'}}>
      <LinearProgress color='secondary' />
    </Box>
  );
};

const AppRoutes = () => {
  const userType = useSelector(selectUserType);
  const user = useSelector(selectUserProfile).userProfile; //use auth user profile not our user state
  const authToken = useSelector(selectUserProfile).token;
  const [submitLoginForm] = useUserLoginMutation();

  if (!user) {
    localStorage.setItem('isLoggedIn', 'false');
  } else {
    if (localStorage.getItem('isLoggedIn') === 'false') {
      if (authToken) {
        // Use ID token instead of access token - ID token has correct audience
        submitLoginForm({email: user.email, token: `Bearer ${authToken.idToken}`});
        localStorage.setItem('isLoggedIn', 'true'); // only set to true after login api called
      }
    }
  }

  let lastInteractionDate: string | number | null = localStorage.getItem('lastInteractionDate');
  if (lastInteractionDate) {
    lastInteractionDate = parseInt(lastInteractionDate);
    const currentTimestamp = Date.now();
    if ((currentTimestamp - lastInteractionDate) / 1000 > 900) {
      window.location.reload();
    }
  }

  localStorage.setItem('lastInteractionDate', String(Date.now()));

  return (
    <Routes>
      {userType ? (
        <Route path='/' element={<RequiredAuth />}>
          <Route path='' element={<HomePage />} />
          <Route path='home' element={<HomePage />} />
          <Route path='search' element={<SearchPage />} />
          <Route path='resources/process-documents' element={<ArtifactsPage type={ArtifactPageType.All} />} />
          <Route path='resources/:resourceSlug?' element={<ResourcePage />} />
          <Route path='process/:processSlug/:modelSlug' element={<ProcessPage />} />
          <Route path='/faq' element={<QuickLinksPage quicklink={E_QuickLinks.Faq} />} />
          <Route path='/pinned' element={<QuickLinksPage quicklink={E_QuickLinks.Pinned} />} />
          <Route path='/help' element={<QuickLinksPage quicklink={E_QuickLinks.Help} />} />
          <Route path='/recent' element={<QuickLinksPage quicklink={E_QuickLinks.Recent} />} />
          <Route path='/login' element={<LogInPage />} />
        </Route>
      ) : (
        <Route path='*' element={<Navigate to='/login' />} />
      )}
      <Route path='/login' element={<LogInPage />} />
      <Route path='/logout' element={<LogoutPage />} />
      <Route path='login/callback' element={<CustomLoginCallback loadingElement={<LoadingElement />} />} />
      <Route path='*' element={<NoFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
